<template>
<div class="wrapper" v-observe-visibility="visibilityChanged">
  <div class="container" :style="{transform}" @mouseenter="paused = true" @mouseleave="paused = false">
    <span class="text" ref="text" v-html="text"></span>
    <span class="text clone" :key="i" v-for="(clone, i) in Array.from(new Array(clones))" v-html="text"></span>
  </div>
</div>
</template>

<script>
import Vue from 'vue'

export default Vue.component('TextMarquee', {
  props: {
    text: {
      type: String,
      required: true
    },
    speed: {
      type: Number,
      required: false,
      default: 1
    }
  },
  data: () => ({
    paused: false,
    reverse: false,
    contentWidth: 0,
    transform: null,
    clones: 0
  }),
  mounted() {
    this.measure()
    this.animate()
    setInterval(this.measure, 1000)
  },
  methods: {
    visibilityChanged(visible, entry) {
      this.paused = !visible
    },
    measure() {
      if(this.$refs.text && !this.paused) {
        this.contentWidth = this.$refs.text.offsetWidth
        const containerWidth = this.$el.offsetWidth
        this.clones = this.contentWidth > containerWidth ? 1 : Math.ceil((containerWidth - this.contentWidth) / this.contentWidth) + 1
      }
    },
    animate(ts = 0) {
      const delta = ts - (this.ts || 0)
      if(!this.paused) {
        const isScrolled = this.reverse ? this.offset < 0 : this.offset > this.contentWidth * -1
        const direction = this.reverse ? -1 : 1
        const reset = this.reverse ? this.contentWidth * -1 : 0

        if(isScrolled) {
          this.offset -= (this.speed * direction * (delta / 16))
        } else {
          this.offset = reset
        }

        this.transform = `translate(${this.offset}px, 0)`
      }

      this.ts = ts

      requestAnimationFrame(this.animate)
    }
  }
})
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
}
.container {
  white-space: nowrap;
}
</style>


// WEBPACK FOOTER //
// src/components/text-marquee.vue